import { flatten, uniqWith } from 'lodash';
import { License, LicenseSeat, LicenseSeatActivation } from 'types/license';
export function getLicenseActivations(license: License): Array<
  {
    seat: LicenseSeat;
  } & LicenseSeatActivation
> {
  return flatten(
    [license].concat(license.Sublicenses).map((sublicense) => {
      return flatten(
        sublicense.Seats.map((seat) => {
          return seat.Activations.map((activation) => {
            return Object.assign({}, activation, {
              seat,
            });
          });
        }),
      );
    }),
  ).filter((activation) => activation.DisplayStatus === 'Active');
}
export function getLicenseUniqueMachines(license: License): Array<
  {
    seat: LicenseSeat;
  } & LicenseSeatActivation
> {
  const activations = getLicenseActivations(license);
  return uniqWith(activations, (a, b) => a.MachineID === b.MachineID);
}
